export default __webpack_public_path__ + "static/media/blogImage3.9627a642.png";